import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// register user function
export const registerUser = async (data) => {
  try {
    const response = await axios.post(BASE_URL + "/auth/register", data);
    return response.data;
  } catch (error) {
    console.error("Error in registering User:", error);
    throw error;
  }
};

// ping server function
export const pingServer = async () => {
  try {
    const response = await axios.get(BASE_URL + "/health");
    console.log("Backend pinged at", new Date().toLocaleTimeString());
    return response;
  } catch (error) {
    console.error("Ping failed:", error);
    throw error;
  }
};

// login user function
export const loginUser = async (data) => {
  try {
    const response = await axios.post(BASE_URL + "/auth/login", data);
    return response;
  } catch (error) {
    console.error("Error in logging in User:", error);
    throw error;
  }
};

// get logged in user details function
export const getLoggedInUser = async (token) => {
  try {
    const response = await axios.get(`${BASE_URL}/auth/me`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error in fetching User details:", error);
    throw error;
  }
};

// get user details function
export const getUserDetails = async (userId, token) => {
  try {
    const response = await axios.get(`${BASE_URL}/users/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error in fetching User details:", error);
    throw error;
  }
};

// update user details function
export const updateUserDetails = async (userId, data, token) => {
  try {
    const response = await axios.patch(`${BASE_URL}/users/${userId}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    console.error("Error in updating User details:", error);
    throw error;
  }
};

// delete user function
export const deleteUser = async (userId, token) => {
  try {
    const response = await axios.delete(`${BASE_URL}/users/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error in deleting User:", error);
    throw error;
  }
};

// get all users function
export const getAllUsers = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/users`);
    return response.data;
  } catch (error) {
    console.error("Error in fetching all Users:", error);
    throw error;
  }
};

// ================ PASSWORD APIs ================

export const forgotPassword = async ({ email }) => {
  try {
    const response = await axios.post(`${BASE_URL}/auth/forgot-password`, {
      email,
    });
    return response.data;
  } catch (error) {
    console.error("Error in forgot password:", error);
    throw error;
  }
};

export const resetPassword = async ({ token, newPassword }) => {
  try {
    const response = await axios.post(`${BASE_URL}/auth/reset-password`, {
      token,
      newPassword,
    });
    return response.data;
  } catch (error) {
    console.error("Error in reset password:", error);
    throw error;
  }
};

// get all users (admin) function
export const getAllUsersAdmin = async (token) => {
  try {
    const response = await axios.get(`${BASE_URL}/users`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error in fetching all Users (admin):", error);
    throw error;
  }
};

// Bulk fetch users by IDs (Admin only)
// POST /admin/users/bulk
// Body: ["id1", "id2"]
// Response: { total: number, users: [{...}, ...] }
export const bulkFetchUsersAdmin = async (userIds, token) => {
  try {
    const response = await axios.post(`${BASE_URL}/admin/users/bulk`, userIds, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error in bulk fetching Users (admin):", error);
    throw error;
  }
};

// ================ SUBSCRIPTION APIs ================

// Subscribe user to job notifications
export const subscribeToJobs = async (userId, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/users/${userId}/subscribe`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error subscribing to jobs:", error);
    throw error;
  }
};

// Unsubscribe user from job notifications
export const unsubscribeFromJobs = async (userId, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/users/${userId}/unsubscribe`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error unsubscribing from jobs:", error);
    throw error;
  }
};


// summary api 
export const getSummary = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/summary`);
    return response.data;
  } catch (error) {
    console.error("Error in fetching summary:", error);
    throw error;
  }
};